/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */
import { l } from '@atproto/lex-schema';
const $nsid = 'com.atproto.label.defs';
export { $nsid };
/** Metadata tag on an atproto resource (eg, repo or record). */
const label = /*#__PURE__*/ l.typedObject($nsid, 'label', 
/*#__PURE__*/ l.object({
    cid: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'cid' })),
    cts: /*#__PURE__*/ l.string({ format: 'datetime' }),
    exp: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'datetime' })),
    neg: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    sig: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.bytes()),
    src: /*#__PURE__*/ l.string({ format: 'did' }),
    uri: /*#__PURE__*/ l.string({ format: 'uri' }),
    val: /*#__PURE__*/ l.string({ maxLength: 128 }),
    ver: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
}));
export { label };
/** Metadata tag on an atproto record, published by the author within the record. Note that schemas should use #selfLabels, not #selfLabel. */
const selfLabel = /*#__PURE__*/ l.typedObject($nsid, 'selfLabel', 
/*#__PURE__*/ l.object({ val: /*#__PURE__*/ l.string({ maxLength: 128 }) }));
export { selfLabel };
const labelValue = /*#__PURE__*/ l.string();
export { labelValue };
/** Metadata tags on an atproto record, published by the author within the record. */
const selfLabels = /*#__PURE__*/ l.typedObject($nsid, 'selfLabels', 
/*#__PURE__*/ l.object({
    values: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref((() => selfLabel)), { maxLength: 10 }),
}));
export { selfLabels };
/** Declares a label value and its expected interpretations and behaviors. */
const labelValueDefinition = /*#__PURE__*/ l.typedObject($nsid, 'labelValueDefinition', 
/*#__PURE__*/ l.object({
    blurs: /*#__PURE__*/ l.string(),
    locales: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref((() => labelValueDefinitionStrings))),
    severity: /*#__PURE__*/ l.string(),
    adultOnly: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    identifier: /*#__PURE__*/ l.string({ maxLength: 100, maxGraphemes: 100 }),
    defaultSetting: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
    /*#__PURE__*/ l.string(), 'warn')),
}));
export { labelValueDefinition };
/** Strings which describe the label in the UI, localized into a specific language. */
const labelValueDefinitionStrings = 
/*#__PURE__*/ l.typedObject($nsid, 'labelValueDefinitionStrings', 
/*#__PURE__*/ l.object({
    lang: /*#__PURE__*/ l.string({ format: 'language' }),
    name: /*#__PURE__*/ l.string({ maxLength: 640, maxGraphemes: 64 }),
    description: /*#__PURE__*/ l.string({
        maxLength: 100000,
        maxGraphemes: 10000,
    }),
}));
export { labelValueDefinitionStrings };
//# sourceMappingURL=defs.defs.js.map